import React, { Component } from 'react'
import { Button, Form, Table, Modal, Input, message, InputNumber, Row, Col } from 'antd'

import { returnTourist, getTouristOrders } from '_src/api/api'

import { getOrderStatusName } from '_src/utils/tool'

import exportExcel from '_src/utils/exportExcel'
import moment from 'moment'

const { Search } = Input
@Form.create({ name: 'Special' })
class Special extends Component {
  constructor (props) {
    super(props)
    this.firstLoad = true // 是否第一次加载
    this.loading = true
    this.param = {
      passengerName: ''
    }
    this.returnParam = { // 价格集合 
      returnPrice: 0,
      totalPrice: 0,
      id: '',
      orderSn: ''
    }
    this.status = ''
    this.pageNum = 0
    this.totalElements = 0
    this.saveDataList = []
    this.state = {
      visible: false,
      dataList: [],
      excelList: [],
    }
  }

  componentDidMount () {
    this.loadData()
  }
  loadData () {
    const { record: {groupDate, id} } = this.props
    
    const { passengerName } = this.param
    let param = {groupDate, travelId: id}
    if (passengerName) {
      param = { ...param, passengerName }
    }
    // const { status, pageNum } = this.param 
    getTouristOrders(param)
      .then(res=>{
        this.loading = false
        const { data } = res
        const dataList = data.map((item, index)=>{
          const { user: { nickname, mobile } } = item
          return {index: (index+1), ...item, key: index, nickname, mobile, opt: getOrderStatusName(item.status) }
        })
        this.saveDataList = dataList
        this.setState(()=>({
          dataList: dataList,
          visible: false
        }))
        if (this.firstLoad) {
          this.firstLoad = false
          this.setState(()=>({
            excelList: dataList
          }))
        }
      })
  }
  columns = () => {
    return [
      {
        title: '排序',
        align: 'center',
        dataIndex: 'index',
        key: 'index',
      },
      {
        title: '订单号',
        align: 'center',
        dataIndex: 'orderSn',
        key: 'orderSn',
        
      },
      {
        title: '用户名称',
        align: 'center',
        dataIndex: 'nickname',
        key: 'nickname',
      },
      {
        title: '用户账号',
        align: 'center',
        dataIndex: 'mobile',
        key: 'mobile',
      },
      // {
      //   title: <span>专题数量</span>,
      //   align: 'center',
      //   dataIndex: 'link',
      //   render: item => <a href={item} target='_blank'>{item}</a>
      // },
      {
        title: '订单价格',
        align: 'center',
        dataIndex: 'orderMoney',
        key: 'orderMoney',
      },
      {
        title: '操作',
        align: 'center',
        dataIndex: 'opt',
        key: 'opt',
        render: (_, record) => {
          const { status } = record
          let Node = null 
          if (status === 10) {
            Node = <Button icon="form" type='primary' onClick={()=>{ this.onEdit(record) }} style = {{marginRight: 10}}>退款</Button>
          }
          if (status === 45) {
            Node = '已退款'
          }
          return (
            <div>
              {Node}
            </div>
          )
        }
      },
    ]
  }

  onEdit (record) {
    const { orderMoney, orderSn, id } = record
    this.returnParam.totalPrice = orderMoney
    this.returnParam.id = id
    this.returnParam.orderSn = orderSn

    this.setState({
      visible: true,
    })
  }
  handleEditCancel = () =>{
    this.setState({
      visible: false,
    })
  }
  handleSearch = (key, v) => {
    this.param[key] = v
    const filterList = !!v?this.saveDataList.filter(item => {
      return item.nickname.indexOf(v) > -1
    }):this.saveDataList
    this.setState({
      dataList: filterList
    })
  }

  handleExcel = () => {
    const { excelList } = this.state
    
    let now = moment().format('YYYY-MM-DD')
    exportExcel(this.columns(), excelList, `退团订单表${now}`) 
  }

  
  onSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { refundMoney } = values
        console.log(values)
        if (refundMoney > this.returnParam.totalPrice) {
          message.error('退款金额不能大于订单金额', 1.5)
          return
        }
        if (refundMoney <= 0) {
          message.error('退款金额小于等于零', 1.5)
          return
        }
        const { id, orderSn } = this.returnParam
        const param = { orderSn, refundMoney }
        returnTourist(id, param).then(res =>{
          this.setState({
            visible: false,
          })
        })
      }
    })
  }

  render () {
    const { dataList, visible } = this.state
    const { getFieldDecorator } = this.props.form
    return (
      <div className = "Special">
        <Form className = "goodlist_from">
          <div style = {{maxWidth: 900}}>
            <Row gutter = {24}>
              <Col span = {8}>
                <Form.Item label = "用户姓名" >
                  <Search placeholder="请输入用户姓名" onSearch={(v)=>{ this.handleSearch('passengerName', v) }} enterButton />
                </Form.Item>
              </Col>
              <Col span = {16}>
                <Form.Item style = {{float: 'right'}}>
                  <Button type = "primary" icon="download" onClick = { this.handleExcel }>导出</Button>
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
        <Table
          loading = {this.loading} 
          bordered
          columns = {this.columns()} 
          dataSource = {dataList}
        />
        <Modal
          title={ '退款'}
          mask = {false}
          visible={visible}
          onCancel={this.handleEditCancel}
          onOk = { this.onSubmit }

          destroyOnClose // 关闭时候销毁
        >
          <Form onSubmit={this.onSubmit} className="advert-form" labelCol = {{span: 4}} wrapperCol = {{span: 18}}>

            <Form.Item label="退款金额" number>
              {getFieldDecorator('refundMoney', { rules: [{ required: true, message: '退款金额不能为空'}] })(
                <InputNumber placeholder="退款金额" />)}
            </Form.Item>
          </Form>
        </Modal>
      </div>
    )
  }
}

export default Special